"use client";

import type React from "react";
import { sendEventToNativeApp } from "../../bridge/helpers";
import { getWindow } from "../../helpers/getWindow";
import { Button } from "../Button";

type Props = {
    children: React.ReactNode;
    url: string;
    className?: string;
    skiAreaSponsoring?: { isSponsored: boolean };
};

export const NavigateButton: React.FC<Props> = ({
    children,
    url,
    className,
    skiAreaSponsoring,
}) => {
    const window = getWindow();

    return (
        <Button
            variant="unstyled"
            className={className}
            onClick={(): void =>
                sendEventToNativeApp({
                    type: "navigate",
                    url,
                    config: {
                        isSkiAreaSponsored:
                            skiAreaSponsoring?.isSponsored ?? false,
                    },
                    prevUrl: window
                        ? window.location.pathname +
                          window.location.search +
                          window.location.hash
                        : "",
                })
            }
        >
            {children}
        </Button>
    );
};
